export function List({ children, className }) {
  return <div className={className}>{children}</div>;
}
